module.exports = __webpack_public_path__ + "static/illust-451dc9f1f4fffbfd6345f81d10fa96f4.png";